import * as THREE from 'three';
import ExtrudedAreaSolid from '../representation3d/ExtrudedAreaSolid';

export default class ExtrudedAreaSolidGeometry {
    static create(extrudedAreaSolid: ExtrudedAreaSolid, material: THREE.Material, layer: number): THREE.Mesh | null {
        const { outerProfile, placement, depth, extrudedDirection } = extrudedAreaSolid;
        
        const outerProfileClone = outerProfile.map((v: any) => new THREE.Vector2(v.x, v.y));

        if (outerProfileClone.length < 3) return null;

        const shape = new THREE.Shape();
        const firstPoint = outerProfileClone.shift() ?? new THREE.Vector2(0,0);
        shape.moveTo(firstPoint.x, firstPoint.y);
        outerProfileClone.forEach((v: any) => shape.lineTo(v.x, v.y));

        const geometry = new THREE.ExtrudeGeometry(shape, { depth: depth, bevelEnabled: false });

        // HACK: When extrusion direction is -Z, move whole ExtrudedAreaSolid geometry to that direction same amount as depth
        if (extrudedDirection.z < 0.0) {
            const v = extrudedDirection.normalize();
            v.multiplyScalar(depth);
            geometry.applyMatrix4(new THREE.Matrix4().makeTranslation(v));
        }

        const mesh = new THREE.Mesh(geometry, material);
        mesh.layers.set(layer);
        
        mesh.position.copy(placement.location);
        mesh.quaternion.copy(placement.getRotationQuaternion());
        
        return mesh;
    }
}
